import { useTheme } from '../../context/ThemeContext';
import { useTranslation } from '../../context/LanguageContext';

export function ThemeToggle() {
  const { theme, toggleTheme } = useTheme();
  const { t } = useTranslation();

  return (
    <button
      onClick={toggleTheme}
      className="win98-button win98-nav-button win98-title"
      style={{
        width: '28px',
        height: '30px',
        padding: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
      title={
        theme === 'light'
          ? t('sunset.theme.switchToDark')
          : t('sunset.theme.switchToLight')
      }
    >
      {theme === 'light' ? '🌙' : '☀️'}
    </button>
  );
}
